import axiosInstance, {headers} from "./axiosInstance";
import { LIST_PI} from "./config";
import {BookingStatusMap} from "../pages/PerformanceIncentive/HeaderFiltersComponent";



export const api = {
    async listPerformanceIncentive(year:number, month:number)
    {
        return axiosInstance.get<PerformanceIncentiveList>(`${LIST_PI}/${year}/${month}`, {headers: headers})
    },
    async approvePerformanceIncentive(year:number, month:number, formData: BookingStatusMap) {
        return axiosInstance.patch<BookingStatusMap>(`${LIST_PI}/${year}/${month}`, formData, {headers: headers});
    },

}
export interface PerformanceIncentiveList{
    metadata: PIMetadata
    data: EmployeeData[]
}
export interface EmployeeData {
  FirstName: string; // varchar(100), not nullable
  EmployeeID: number; // int, not nullable
  WorkDate: string; // date, not nullable (ISO 8601 string)
  AddedValue: number; // int, not nullable
  IncentivePercentage: number; // decimal(5,2), not nullable
  customerOrStrypes: string;
  Project: string; // varchar(255), not nullable
  StoryID: string; // varchar(50), not nullable
  DepartmentName: string; // varchar(100), not nullable
  GM: string; // varchar(100), not nullable
  Note?: string; // text, nullable
  IsInternalEmployee: boolean; // tinyint(1), not nullable (boolean)
  BookingID: string; // varchar(50), primary key, not nullable
  Month: number; // tinyint, indexed, not nullable
  Year: number; // smallint, not nullable
  approved?: boolean; // tinyint(1), nullable (boolean)
  approvalLog?: string; // varchar(60), nullable
}
export interface PIMetadata{
    month: number;
    year:number;
    generation_time: string
    previous_generation_time: string
    status: string
}